import React from 'react'
import DigitalMarketingHero from '../../../Components/DigitalMarketing/DigitalMarketingHero'
import DigitalMarketingServices from '../../../Components/DigitalMarketing/DigitalMarketingServices'
import DigitalMarketingchooseus from '../../../Components/DigitalMarketing/DigitalMarketingchooseus'
import Projectform from '../../../Components/Projects/Projectform'
import DigitalMarketingclients from '../../../Components/DigitalMarketing/DigitalMarketingclients'
const DigitalMarketing = () => {
  return (
    <>
    <DigitalMarketingHero/>
    <DigitalMarketingServices/>
    {/* <DigitalMarketingclients/> */}
    <DigitalMarketingchooseus/>
    <Projectform/>
    </>
  )
}

export default DigitalMarketing